import { ChangeDetectionStrategy, Component, computed, input, model, viewChild } from '@angular/core';
import { ChoiceOptions } from './choice-options.model';
import { IFormInput, IFormModel } from '@mwe/models';
import { FormComponent } from '../form/form.component';
import {
  containsStromGasAndWaermeProducts,
  containsStromOrGasCategory,
  isProductCategoryEmobilityOrInternetOrFernwaerme,
} from '@mwe/utils';

@Component({
  selector: 'mwe-choices',
  templateUrl: './choices.component.html',
  imports: [FormComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChoicesComponent {
  private choiceNamePrefix = 'choices-';
  options = input<ChoiceOptions[]>([]);
  selectedOption = model<unknown>();
  form = viewChild<FormComponent>(FormComponent);
  formModel = computed<IFormModel>(() => {
    const inputs: IFormInput[] = this.options().map(item => {
      const after = () => {
        const categories = (item.data as any).categories;

        if (containsStromGasAndWaermeProducts(categories)) {
          return 'voucher.choices.legal.sgw';
        }
        if (containsStromOrGasCategory(categories)) {
          return 'voucher.choices.legal.sg';
        }
        if (isProductCategoryEmobilityOrInternetOrFernwaerme(categories)) {
          return 'voucher.choices.legal.its';
        }
        return '';
      };
      return {
        name: 'choices',
        radioValue: item.value as string,
        componentType: 'selectable-card-radio',
        initialValue: false,
        inputClasses: 'col-md-6',
        content: {
          categories: (item.data as any).categories,
          address: (item.data as any).address,
          after: after(),
        },
      };
    });
    return {
      name: 'group',
      updateOn: 'change',
      inputs: [
        {
          name: 'choices',
          inputs: inputs,
        },
      ],
    } as IFormModel;
  });

  onFormChanged(event: { choices: string }) {
    this.selectedOption.set(event.choices);
  }
}
